// extracted by mini-css-extract-plugin
export var button = "_8q-7";
export var buttonRow = "_8q-6";
export var fadeIn = "_8q-1";
export var gradient = "_8q-0";
export var panel = "_8q-2";
export var panelIn = "_8q-3";
export var subtitle = "_8q-5";
export var title = "_8q-4";